export const V1_BASE_URL = '/v1/';

export const EDITABLE_HTML_TAGNAMES = [
  'INPUT', 'TEXTAREA', 'SELECT',
];
